import React from "react";
import * as MenuPrimitive from "@radix-ui/react-dropdown-menu";
import { cn } from "../../../lib/utils";
import { PORTAL_SURFACE } from "./classes";

/**
 * A dropdown menu on the raised surface (wireframes: "⋮ more", "Saved views ▾").
 *
 * `items` is `[{key, label, onSelect, tone?: "danger", hint?, testId?, disabled?}]` or
 * `{separator: true}`; `header` is an optional muted caption at the top ("⋮ more").
 */
export default function CrmMenu({ trigger, items, header, align = "end", testId }) {
  return (
    <MenuPrimitive.Root modal={false}>
      <MenuPrimitive.Trigger asChild>{trigger}</MenuPrimitive.Trigger>
      <MenuPrimitive.Portal>
        <MenuPrimitive.Content
          align={align}
          sideOffset={6}
          data-testid={testId}
          className={cn(PORTAL_SURFACE, "z-50 min-w-[14rem] rounded-2xl p-2")}
        >
          {header && <div className="px-3 pt-1 pb-2 text-xs text-eh-muted">{header}</div>}
          {items.map((item, i) => (item.separator
            ? <MenuPrimitive.Separator key={`sep-${i}`} className="my-1 h-px bg-eh-border-soft" />
            : (
              <MenuPrimitive.Item
                key={item.key}
                disabled={item.disabled}
                onSelect={item.onSelect}
                data-testid={item.testId}
                className={cn(
                  "cursor-pointer select-none rounded-2xl px-3 py-2.5 text-sm outline-none",
                  "data-[highlighted]:bg-eh-cream data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed",
                  item.tone === "danger" ? "text-red-700" : "text-eh-ink",
                )}
              >
                {item.label}
                {item.hint && <span className="ml-1 text-xs">{item.hint}</span>}
              </MenuPrimitive.Item>
            )))}
        </MenuPrimitive.Content>
      </MenuPrimitive.Portal>
    </MenuPrimitive.Root>
  );
}
